import { createFileRoute, redirect } from "@tanstack/react-router"

import { portalOrganisations } from "@/app/landing"
import { OrganisationPicker } from "@/features/organisations/components/organisation-picker"
import { PortalChooser } from "@/features/portal/components/portal-chooser"

export const Route = createFileRoute("/_authenticated/organisations/select/")({
  beforeLoad: ({ context }) => {
    const { session } = context
    const [only, ...others] = session.organisations

    if (only && others.length === 0) {
      throw redirect({
        to: "/$organisation",
        params: { organisation: only.id },
      })
    }

    if (!only && portalOrganisations(session).length === 0) {
      throw redirect({
        to: session.user.admin ? "/admin" : "/organisations/none",
      })
    }
  },
  component: SelectOrganisationPage,
})

function SelectOrganisationPage() {
  const { session } = Route.useRouteContext()

  return session.organisations.length > 0 ? (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="w-full max-w-md">
        <OrganisationPicker />
      </div>
    </div>
  ) : (
    <PortalChooser linked={session.portal} />
  )
}
